'use client';
import { useStytchMember, useStytchMemberSession } from '@stytch/nextjs/b2b';
/** Session state for AuthProvider consumers, including those without AuthManager. */
export function useAuthSession() {
    const { session, isInitialized: sessionInitialized } = useStytchMemberSession();
    const { member, isInitialized: memberInitialized } = useStytchMember();
    return {
        session,
        member,
        isAuthenticated: Boolean(session),
        isLoading: !sessionInitialized || !memberInitialized,
    };
}
